import { Input, Tooltip } from "antd";
import { orderCancellationRemark } from "modules/navbar/top/helper";
import React, { useState } from "react";
import { useOrderCancellation } from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { Button, CloseButton, Form, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import secureLocalStorage from "react-secure-storage";

const PrescriptionDenyModal = ({ currentId }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRemark, setSelectedRemark] = useState(null);
  const [comment, setComment] = useState("");
  const { cancelOrderData, fetchOrderCancellation } = useOrderCancellation();
  const { setToaster } = useToast();

  const handleCancelOrder = () => {
    setIsModalVisible(true);
  };

  const handleRemarkChange = (e) => {
    setSelectedRemark(e.target.value);
  };

  const handleCommentChange = (e) => {
    setComment(e.target.value);
  };

  const handleCancelConfirmation = async () => {
    setIsModalVisible(false);
    const payload = {
      order_display_id: currentId,
      category: "order_related",
      subcategory: "auto_order_cancellation_initiated",
      remark: selectedRemark,
      comment: comment,
      isDeniedPrescription: true,
      doctorId: secureLocalStorage.getItem("id") || "",
    };
    await fetchOrderCancellation(payload, toast );
  };

  return (
    <div>
      <Tooltip title="Deny Prescription">
        <div>
          <button className="btn btn-danger" onClick={handleCancelOrder}>
            Deny Prescription
          </button>
        </div>
      </Tooltip>

      <Modal
        show={isModalVisible}
        onHide={() => setIsModalVisible(false)}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        style={{ zIndex: "99999999" }}
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            Deny Prescription
          </Modal.Title>
          <CloseButton
            className="btn btn-circle btn-sm transition-base p-0"
            onClick={() => setIsModalVisible(false)}
          />
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="d-flex gap-4">
              <div className="fw-bold text-black">Order ID:</div>
              <div className="text-black">{currentId}</div>
            </div>
            <div className="d-flex gap-4">
              <div className="fw-bold text-black">Category:</div>
              <div className="ms-n1 text-black">Order Related</div>
            </div>
            <div>
              <strong className="fw-bold text-black">Subcategory:</strong>
              <span className="text-black ms-1">
                Auto Order Cancellation Initiated
              </span>
            </div>
            <div>
              <label className="text-black">Remark:</label>
              <Form.Select
                value={selectedRemark}
                onChange={(e) => handleRemarkChange(e)}
                style={{ width: "100%", zIndex: "999999999" }}
                placeholder="Select a remark"
              >
                <option value="">Select a remark</option>
                {orderCancellationRemark.map((remark, index) => (
                  <option key={index} value={remark?.value}>
                    {remark?.label}
                  </option>
                ))}
              </Form.Select>
            </div>
            <div style={{ marginTop: "1rem" }}>
              <label className="text-black">Comment:</label>
              <Input.TextArea
                value={comment}
                onChange={handleCommentChange}
                placeholder="Enter your comments here"
                rows={4}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleCancelConfirmation}>Save</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default PrescriptionDenyModal;
